define('plugin/client-login/view/ClientLoginInfoView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Client login view
     *
     * @class ClientLoginInfoView
     */
    return LayoutView.extend({

        template: '#client_login_info',
        ui: {
            'sign_out_btn': '#sb_sign_out_btn'
        },
        triggers: {
            'click @ui.sign_out_btn': 'signOut'
        },
        modelEvents: {
            'sync': 'stepDone'
        },

        initialize: function () {
            this._step = this.getOption('step');
        },

        stepDone: function () {
            this._step.done();
        }

    });

});
